import { useAuth } from "oidc-react";
import { useEffect, useState } from "react";
import Branding from "./Branding/Branding";
import { ApsAppContent } from "UserExperience/portal-vnext";
import { useHttp } from "../../../../common/http/httpService";
import { useHistory, useLocation } from "react-router";
import Header from "./Header/Header";

const BrandedContent = ({ children }) => {

  const auth = useAuth();
  const http = useHttp();
  const location = useLocation();
  const history = useHistory();
  const [brandSettings, setBrandSettings] = useState(null);
  const [directionClass, setDirectionClass] = useState('nav-setting-is-forward');

    useEffect(() => {
      if (history.action === 'POP') {
        setDirectionClass('nav-setting-is-back');
      } else {
        setDirectionClass('nav-setting-is-forward');
      }
    }, [location, history.action]);

    useEffect(() => {
      const loadBrandSettings = async() => {
        const results = await http.get('/brand');
        setBrandSettings(results);
      };
  
      if (!auth.isLoading && auth.userData) {
        loadBrandSettings();
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth.isLoading, auth.userData])    


  return (
    brandSettings !== null ? (
    <ApsAppContent className={directionClass}>
      <Branding brandSettings={brandSettings} />
      <Header
        brandLogoUrl={brandSettings?.logoFileUrl}
        brandName={brandSettings?.name}
      />    
      {children}
    </ApsAppContent>
    ) : null
  );
}

export default BrandedContent;